module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/color-8640ea538b94fc0d1f0693106c948da4.svg";